(function () {
  'use strict';

  var widgetSelector = '.yv-product-card .snap_collection_category.snap_mobile_widget';
  var scheduled = false;

  function createText(className, text) {
    var element = document.createElement('span');
    element.className = className;
    element.textContent = text;
    return element;
  }

  function buildVisual(widget) {
    var existingChildren = Array.from(widget.children);
    existingChildren.forEach(function (child) {
      child.classList.add('mrjewels-snapmint-card__source');
      child.setAttribute('aria-hidden', 'true');
    });

    var visual = document.createElement('span');
    visual.className = 'mrjewels-snapmint-card__visual';
    visual.setAttribute('data-snapmint-card-visual', '');
    visual.setAttribute('aria-hidden', 'true');

    var copy = document.createElement('span');
    copy.className = 'mrjewels-snapmint-card__copy';
    copy.appendChild(createText('mrjewels-snapmint-card__prefix', 'EMI ₹'));

    var amount = createText('mrjewels-snapmint-card__amount', '');
    amount.setAttribute('data-snapmint-card-amount', '');
    copy.appendChild(amount);
    copy.appendChild(createText('mrjewels-snapmint-card__suffix', '/mo'));

    visual.appendChild(copy);
    visual.appendChild(createText('mrjewels-snapmint-card__divider', '·'));
    visual.appendChild(createText('mrjewels-snapmint-card__link', 'View options'));
    widget.appendChild(visual);
  }

  function addKeyboardSupport(widget) {
    if (widget.hasAttribute('data-snapmint-card-keyboard')) {
      return;
    }

    widget.setAttribute('data-snapmint-card-keyboard', '');
    widget.setAttribute('role', 'button');
    widget.setAttribute('tabindex', '0');
    widget.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      widget.click();
    });
  }

  function initializeWidget(widget) {
    var sourceAmount = widget.querySelector(
      '.mrjewels-snapmint-card__source .dp-collection-price, .dp-collection-price'
    );
    var amount = sourceAmount ? sourceAmount.textContent.trim() : '';
    var visual = widget.querySelector('[data-snapmint-card-visual]');

    if (!visual) {
      buildVisual(widget);
      visual = widget.querySelector('[data-snapmint-card-visual]');
    }

    addKeyboardSupport(widget);

    var visibleAmount = visual.querySelector('[data-snapmint-card-amount]');
    if (visibleAmount && visibleAmount.textContent !== amount) {
      visibleAmount.textContent = amount;
    }

    widget.classList.toggle('mrjewels-snapmint-card--ready', amount.length > 0);
    if (amount.length > 0) {
      widget.setAttribute('aria-label', 'EMI ₹' + amount + ' per month. View EMI options.');
    } else {
      widget.removeAttribute('aria-label');
    }
  }

  function initializeWidgets() {
    document.querySelectorAll(widgetSelector).forEach(initializeWidget);
  }

  function scheduleInitialization() {
    if (scheduled) {
      return;
    }

    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      initializeWidgets();
    });
  }

  function start() {
    initializeWidgets();

    var observer = new MutationObserver(scheduleInitialization);
    observer.observe(document.documentElement, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
